import mapAuthenticationContext from '../methods/mapAuthenticationContext';
import { Kpi } from '../loggers/Kpi';
import { axiosService } from '../services/axios.service';
import { HttpHeader } from '../types/enums/http-header.enum';
import { LookupService } from '../services/lookup-service/lookup.service';
export class State {
    constructor(payload) {
        this.getNudetectWidgetData = () => Promise.resolve('');
        this.payload = payload;
        this.srcClientId = payload.srcClientId;
        this.srcCorrelationId = payload.srcCorrelationId;
        this.srciTransactionId = payload.srciTransactionId;
        this.traceId = payload.traceId;
        this.serviceId = payload.serviceId;
        this.dasClientId = payload.dasClientId;
        this.dasHost = payload.dasHost;
        this.namespace = payload.namespace;
        this.dpaData = payload.dpaData;
        this.dpaTransactionOptions = payload.dpaTransactionOptions;
        this.getNudetectWidgetData = payload.getNudetectWidgetData || this.getNudetectWidgetData;
        this.srcDpaId = payload.srcDpaId;
        this.kpi = new Kpi(payload);
        this.lookupService = new LookupService(payload, this.kpi);
        axiosService.setGlobalHeaders({
            [HttpHeader.SRC_CORRELATION_ID]: payload.srcCorrelationId,
            // TODO: I think we need it? The same pattern exists in DCF, so I thought it is worth adding it here
            [HttpHeader.X_SRC_TRACE_ID]: payload.traceId
        });
    }
    /**
     * Returns an {@link AuthenticationContext | `AuthenticationContext`}.
     *
     * @deprecated as of EMVCo 1.4.
     */
    getAuthenticationContext(context = {}) {
        return mapAuthenticationContext(Object.assign({ authenticationReasons: context.authenticationReasons || [], srcDpaId: this.srcDpaId, dpaTransactionOptions: this.dpaTransactionOptions, dpaData: this.dpaData }, context));
    }
}
